<template>
  <hcc-dropdown
    :custom="true"
    position="top-right"
    customClass="dropdown-position"
  >
    <template #button>
      <div class="navigation__profile" role="button">
        <user-profile :size="30" :name="userName" :picture="profilePicture" />
        <div
          class="navigation__profile-status"
          :class="[`navigation__profile-status--${status}`]"
        ></div>
      </div>
    </template>
    <hcc-dropdown-item @click="logoutUser">
      {{ $t("user-menu.logout") }}
    </hcc-dropdown-item>
    <hcc-dropdown-item @click="updateStatus">
      {{ active ? "Stand-by" : $t("user-menu.active") }}
    </hcc-dropdown-item>
    <hcc-dropdown-item @click="openFAQ" customClass="menu-link">
      FAQ
    </hcc-dropdown-item>
  </hcc-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { onLogout } from '@/vue-apollo';
import apolloProvider from '@/apollo';
import userChangeStatus from '@/graphql/mutations/userChangeStatus.gql';
import HccDropdown from '@/components/shared/HccDropdown/index.vue';
import HccDropdownItem from '@/components/shared/HccDropdown/DropdownItem.vue';
import UserProfile from '@/components/UserProfile.vue';

export default {
  components: {
    UserProfile,
    HccDropdown,
    HccDropdownItem,
  },
  computed: {
    ...mapGetters(['userInfo']),
    profilePicture() {
      return this.userInfo.profilePic ?? '';
    },
    status() {
      return this.userInfo.status;
    },
    userName() {
      return this.userInfo.name;
    },
    active() {
      return this.status === 'online';
    },
    isActive() {
      return this.active ? 'STANDBY' : 'ONLINE';
    },
  },
  methods: {
    async logoutUser() {
      await this.changeStatus('OFFLINE');
      onLogout(apolloProvider.defaultClient);
    },
    async updateStatus() {
      await this.changeStatus(this.isActive);
    },
    changeStatus(status) {
      return this.$apollo.mutate({
        mutation: userChangeStatus,
        variables: {
          id: this.userInfo.id,
          status,
        },
      });
    },
    openFAQ() {
      window.open('https://blog.heycenter.com/preguntas-frecuentes/', '_blank', 'noopener, noreferrer');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/_user_menu.scss";

.profile__class {
  background-color: $secondary;
  border: 1px solid $gray-light;
  box-shadow: 0 0 0 1px $gray-light, 0 3px 6px 0 rgba(0, 0, 0, 0.25),
    0 6px 10px -1px rgba(0, 0, 0, 0.25);
}

::v-deep .profile__class-name {
  color: $gray-light;
  font-size: 16px;
}
</style>
